import { render, staticRenderFns } from "./EditTeacher.vue?vue&type=template&id=3fd8ef63&scoped=true&lang=true&"
import script from "./EditTeacher.vue?vue&type=script&lang=js&"
export * from "./EditTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd8ef63",
  null
  
)

export default component.exports